import type { Schedule } from '../assets/types';
import type { FulfillmentCenterConfig } from '../services/FulfillmentConfigService/types';
import { isWithinInterval, parseISO } from 'date-fns';
import type { PartnerAddressV2, PartnerContact, PartnerOrigin } from '@shipium-corp/shipium-ts-types';

export const originAssetsToFulfillmentCenter = (
  origins: Record<string, PartnerOrigin> = {},
  schedules: Record<string, Schedule> = {},
  addresses: Record<string, PartnerAddressV2> = {},
  contacts: Record<string, PartnerContact> = {},
): Partial<FulfillmentCenterConfig[]> => {
  return Object.values(origins ?? {})
    .map((o) => {
      const address = addresses[o.addressId];
      const schedule = schedules[o.scheduleId!];
      const contact = contacts[o.contactId];
      const currentEntry = schedule?.entries?.find((val) => {
        return isWithinInterval(new Date(), { start: parseISO(val.from), end: parseISO(val.to) });
      });
      if (!!address && !!contact && !!schedule && !!currentEntry) {
        return {
          ...o,
          fulfillmentCenterId: o.originId,
          holidates: (currentEntry?.holidays as any) || [],
          fcPartnerId: o.partnerId,
          address: { ...address?.location, state: address?.location?.region },
          validatedAddressMetadata: address?.location?.validatedAddressMetadata,
          shippingDays: currentEntry?.shippingDays,
          processingCutoff: currentEntry?.processingCutoff,
          ...currentEntry?.processingCutoff,
          shippingContact: {
            ...contact,
            emailAddress: contact.email!,
            phoneNumber: contact.phoneNumber!,
            name: contact.name!,
          },
          ...currentEntry?.processingCutoff,
          weekendCutoff: currentEntry?.processingCutoff?.weekendCutoff,
          isDropshipper: o.originType === 'at_large',
        };
      }
      return undefined;
    })
    .filter((val) => !!val);
};
